<div class="modal-dialog" [attr.role]="'document'">
  <div class="modal-content">
    <p class="col-sm-2 col-sm-offset-10">
      <button class="btn btn-default-reverse btn-block btn-sm" data-dismiss="modal"
              type="button" (click)="manageModal()">Chiudi
      </button>
    </p>
    <div>
      <div class="col-sm-12 coldx">
        <h4>Sincronizza Calendario</h4>
        <div class="row">
          <div class="col-sm-12">
            <p>
              <label for="link-calendar-lbl">Link</label>
            </p>
            <div class="input-group" style="margin-bottom: 10px">
              <input id="link-calendar-lbl" class="form-control" style="border: 1px solid #ccc;" type="text" [value]="calendarLinkUrl" readonly #calendarLinkInput>
              <span class="input-group-addon" (click)="copy()" id="calendarLinkCopyButton">
                <span class="glyphicon glyphicon-copy" style="margin-left: 0px"></span>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-8">
            <p>Utilizza questo link per accedere al calendario da altre applicazioni.</p>
          </div>
          <div class="col-sm-4">
            <p class="fade" #calendarLinkCopyAlert>
              <span style="float: right; color: black; font-style: italic">Link copiato negli appunti!</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
